import { InjectionToken } from '@angular/core';
import { BackendurlService } from '~/services/BackEndURL/backendurl.service';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export function apiBaseUrlFactory(backendUrlService: BackendurlService): string {
  return backendUrlService.barcloudUrl || '';
}

export const API_BASE_URL_PROVIDER = {
  provide: API_BASE_URL,
  useFactory: apiBaseUrlFactory,
  deps: [BackendurlService]
};
